export const RESEARCH_LOAD_DATA = "RESEARCH_LOAD_DATA";
export const RESEARCH_SET_PAGE = "RESEARCH_SET_PAGE";
export const RESEARCH_NEXT_PAGE = "RESEARCH_NEXT_PAGE";
export const RESEARCH_PREV_PAGE = "RESEARCH_PREV_PAGE";
export const RESEARCH_OPEN_HELP = "RESEARCH_OPEN_HELP";
export const RESEARCH_CLOSE_HELP = "RESEARCH_CLOSE_HELP";
export const RESEARCH_SAVE_ACTIVITY = "RESEARCH_SAVE_ACTIVITY";
export const RESEARCH_SAVE_ACTIVITY_SUCCESS = "RESEARCH_SAVE_ACTIVITY_SUCCESS";
export const RESEARCH_SAVE_ACTIVITY_FAILURE = "RESEARCH_SAVE_ACTIVITY_FAILURE";
